// Timer helper functions and data

export const renderTimeNode = (text: number, length = 2) => {
  return text.toString().padStart(length, "0");
};
